import {
  AutoComplete,
  Modal,
  Button,
  Icon,
  Input,
  Spin,
  Table,
  Dropdown,
  Menu,
  Popconfirm,
  Empty,
} from "antd";
import React from "react";
import Highlighter from "react-highlight-words";
import "../../components/general/drawer/AdaptiveDrawer.css";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { UserService } from "../../services/user/UserService";
import { CfgUserService } from "../../services/cfgUser/CfgUserService";
import { handleError } from "../../utils/ErrorHandlers";
import { showSuccessToast } from "../general/ToastHelper";
import "../systemConfig/SystemConfig.css";
import history from "../../utils/history";
import { Constants } from "../../data/constants";
import { Translation } from "react-i18next";
import i18next from "i18next";
class UsersTable extends React.Component {
  constants = new Constants();
  constructor(props) {
    super(props);
    this.userService = new UserService();
    this.userCfgService = new CfgUserService();
    this.state = {
      isFetching: false,
      searchText: "",
      data: [],
      cfgData: [],
      usersGroupList: [],
    };
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={i18next.t(`Search ${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={
            this.props.context.curr_dir === "ltr" &&
            this.props.context.curr_lang === "en"
              ? { width: 100, marginRight: 8 }
              : { width: 100, marginLeft: 8 }
          }
        >
          {i18next.t("Search")}
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 80 }}
        >
          {i18next.t("Reset")}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: "#d73a31" }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] != null &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text}
      />
    ),
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  async componentDidMount() {
    try {
      this.setState({ isFetching: true });
      this.getAllUsers();
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  getEachCfgKey(dataMapped) {
    let cfgStatus = "";
    dataMapped.forEach((el, index) => {
      if (el.key === "AGENT_STATUS") {
        cfgStatus = el.value;
      }
    });
    return cfgStatus;
  }

  mapUserCfg(data, cfgData) {
    data.forEach((element, index) => {
      let cfgMapped = cfgData.filter(
        (cfgEl) => element.userId === cfgEl.userId
      );

      data[index].userCfgStatus = this.getEachCfgKey(cfgMapped);
    });
    return this.formatData(data);
  }

  async getAllUsers() {
    try {
      let data = await this.userService.getUsersByAccountIdAndGroupIdService(
        this.props.context.session_id,
        this.props.groupId.id
      );
      let dataAfterFormat =
        data.ivrList.length !== 0
          ? this.mapUserCfg(data.ivrList, data.cfgList)
          : this.setState({ isFetching: false });
      this.setState({ data: dataAfterFormat, isFetching: false });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }
  showModal = async () => {
    this.setState({
      visible: true,
    });
    let { usersGroupList } = this.state;
    this.acc = new UserService();
    let usersGroup = await this.acc.getUsersByType(
      this.props.context.session_id,
      this.constants.userTypeList.agent
    );

    usersGroupList = usersGroup.ivrList;
    this.setState({ usersGroupList });
  };

  formatData(data) {
    const updated_data = [];
    for (var i = 0; i < data.length; i++) {
      var row = {};
      row["key"] = i + 1;
      row["userFullname"] = data[i]["userFullname"];
      row["userEmail"] = data[i]["userEmail"];
      row["userCfgStatus"] = data[i]["userCfgStatus"];
      row["userNumber"] = data[i]["userNumber"];
      row["userId"] = data[i]["userId"];

      updated_data.push(row);
    }

    return updated_data;
  }
  submitAddUser = async (e) => {
    let userId = this.state.userId;

    let accountId = this.props.context.user.accountId;
    let groupId = this.props.groupId.id;

    this.acc = new UserService();
    try {
      let assignUserGroup = await this.acc.assignUserGroup(
        this.props.context.session_id,
        groupId,
        userId
      );

      showSuccessToast(i18next.t("User assigned successfully"));
      this.getAllUsers();
      this.handleRefresh();
      this.setState({
        visible: false,
      });
    } catch (e) {
      this.setState({ visible: true });
      this.handleRefresh();
      this.setState({ isFetching: false });
      handleError(e);
    }
  };
  handleRefresh() {
    this.setState({ isFetching: true });
    this.props.onRefresh();
  }
  async deleteUser(userId) {
    try {
      let data = await this.userService.deleteUserFromGroup(
        this.props.context.session_id,
        this.props.groupId.id,
        userId
      );
      showSuccessToast(i18next.t(data.statusMsg));
      this.getAllUsers();
    } catch (e) {
      handleError(e);
    }
  }

  viewUser(userId) {
    history.push(`/home/users/view/${userId}`);
  }
  editUSer(userId) {
    history.push(`/home/users/edit/${userId}`);
  }

  renderUserDropdown(user) {
    const menu = (
      <Menu>
        <Menu.Item onClick={() => this.editUSer(user.userId)}>
          <span>{i18next.t("Update User")}</span>
          <Icon className={"edit-account-style"} type="edit" />
        </Menu.Item>
        <Menu.Item>
          <Popconfirm
            title={i18next.t("Are you sure you want to remove this user?")}
            onConfirm={() => this.deleteUser(user.userId)}
            okText={i18next.t("Yes")}
            cancelText={i18next.t("No")}
          >
            <a href="#" style={{ color: "rgba(0, 0, 0, 0.65)" }}>
              {i18next.t("Remove")}
              <Icon className={"delete-account-style"} type="delete" />
            </a>
          </Popconfirm>
        </Menu.Item>
        <Menu.Item onClick={() => this.viewUser(user.userId)}>
          <span>{i18next.t("View User")}</span>
          <Icon className={"view-details-style"} type="eye" />
        </Menu.Item>
      </Menu>
    );
    return (
      <Dropdown overlay={menu}>
        <Button size="small" style={{ borderWidth: 0 }}>
          <Icon item={user} type="more" />
        </Button>
      </Dropdown>
    );
  }
  renderTitle(title) {
    return <span>{title}</span>;
  }
  handleCancel = () => {
    this.setState({ visible: false });
  };

  onChange = (value) => {
    let userId = this.state;
    userId = value;

    this.setState({ userId });
  };
  onSelect = (value) => {
    this.setState({ value });
  };
  handleRefresh() {
    this.setState({ isFetching: true });
    this.props.onRefresh();
  }
  itemRender = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        <a className="ant-pagination-item-link">
          <Icon
            type={this.props.context.curr_dir === "rtl" ? "right" : "left"}
          />
        </a>
      );
    }
    if (type === "next") {
      return (
        <a className="ant-pagination-item-link">
          <Icon
            type={this.props.context.curr_dir === "rtl" ? "left" : "right"}
          />
        </a>
      );
    }
    return originalElement;
  };

  render() {
    const { Option } = AutoComplete;

    const columns = [
      {
        title: i18next.t("Full Name"),
        dataIndex: "userFullname",
        key: "userFullname",
        width: "30%",
        ...this.getColumnSearchProps("userFullname"),
      },
      {
        title: i18next.t("Email"),
        dataIndex: "userEmail",
        key: "userEmail",
        width: "40%",
        ...this.getColumnSearchProps("userEmail"),
      },
      {
        title: i18next.t("Phone Number"),
        dataIndex: "userNumber",
        key: "userNumber",
        width: "20%",
        ...this.getColumnSearchProps("userNumber"),
      },
      {
        title: i18next.t("Status"),
        dataIndex: "userCfgStatus",
        key: "userCfgStatus",
        width: "20%",
        ...this.getColumnSearchProps("userCfgStatus"),
      },
      {
        title: i18next.t("Action"),
        dataIndex: "operation",
        render: (text, record) =>
          this.state.data.length >= 1 ? this.renderUserDropdown(record) : null,
      },
    ];

    let { isFetching, usersGroupList } = this.state;
    const options = usersGroupList.map((opt) => (
      <Option key={opt.userName} value={opt.userId}>
        {opt.userName}
      </Option>
    ));
    return (
      <div>
        {isFetching ? (
          <Spin></Spin>
        ) : (
          <Translation>
            {(t) => (
              <div>
                <Button
                  style={{ marginTop: "50px" }}
                  className="button-add-account"
                  onClick={this.showModal}
                  icon="plus"
                />
                <span>{t("Add User")}</span>
                <Table
                  bodyStyle={{
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                    borderRadius: "8px",
                    marginBottom: "10px",
                  }}
                  columns={columns}
                  dataSource={this.state.data}
                  bordered
                  pagination={{
                    position: "bottom",
                    pageSize: 10,
                    itemRender: this.itemRender,
                  }}
                  locale={{
                    emptyText: (
                      <Empty
                        description={i18next.t("Empty")}
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                      />
                    ),
                  }}
                />
                <Modal
                  title={t("Add user")}
                  visible={this.state.visible}
                  onOk={this.submitAddUser}
                  onCancel={this.handleCancel}
                  okText={t("OK")}
                  cancelText={t("Cancel")}
                >
                  <AutoComplete
                    className="certain-category-search"
                    dropdownClassName="certain-category-search-dropdown"
                    dropdownMatchSelectWidth={false}
                    dropdownStyle={{ width: 300 }}
                    size="large"
                    style={{ width: "100%" }}
                    dataSource={options}
                    placeholder={t("input here")}
                    onSelect={this.onSelect}
                    onChange={this.onChange}
                    filterOption={(inputValue, option) =>
                      option.props.children
                        .toUpperCase()
                        .indexOf(inputValue.toUpperCase()) !== -1
                    }
                  >
                    <Input
                      suffix={
                        <Icon type="search" className="certain-category-icon" />
                      }
                    />
                  </AutoComplete>
                </Modal>
              </div>
            )}
          </Translation>
        )}
      </div>
    );
  }
}

export default withSharedStateConsumer(UsersTable);
